import React from "react";
import { NavLink } from "react-router-dom";

export default function GrayBanner(props: any) {
  return (
    <div className={`${props.padding ? "p-4" : ""} w-full`}>
      <div className="bg-main-gray px-5 sm:px-10 lg:px-16 py-14 sm:py-16">
        <div className="mx-auto max-w-[1100px] flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="w-full lg:w-[38%] lg:shrink-0 border-l-4 border-main pl-6">
            <p className="text-main text-xs font-bold tracking-[0.15em] uppercase mb-3">
              {props.tag}
            </p>
            <h2 className="font-headings text-3xl sm:text-4xl font-bold text-gray-900 leading-tight mb-6">
              {props.title}
            </h2>
            <NavLink
              to="/contact-us"
              className={`inline-block text-base uppercase text-white font-body px-6 py-2.5 tracking-wide bg-${props.button.color} hover:bg-main-darker transition-colors`}
            >
              {props.button.text}
            </NavLink>
          </div>
          <div className="flex flex-col gap-4 text-gray-600 text-base sm:text-lg leading-relaxed font-body lg:pt-1 lg:border-l lg:border-gray-200 lg:pl-16">
            {props.content}
          </div>
        </div>
      </div>
    </div>
  );
}
